import * as Icons from "lucide-react";
import { WHY_CHOOSE_US } from "@/lib/site";

export const WhyChooseUs = () => (
  <section id="about" className="relative py-24 lg:py-32 bg-slate-50" data-testid="why-section">
    <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="grid lg:grid-cols-3 gap-16 items-start">
          <div>
            <div className="text-xs uppercase tracking-[0.2em] font-semibold text-brand-purple">Why us</div>
            <h2 className="section-heading text-3xl sm:text-4xl lg:text-5xl mt-3 text-slate-900">
              Built for <span className="text-gradient">outcomes</span>, not outputs.
            </h2>
            <p className="mt-5 text-slate-600 leading-relaxed">
              We pair enterprise-grade engineering with startup speed. Every project is delivered by a dedicated team, backed by AI-powered workflows and modern best practices.
            </p>
            <div className="mt-6 rounded-3xl overflow-hidden border border-slate-100 soft-shadow-lg">
              <img
                src="/images/about/team.jpg"
                alt="ClomedixTech collaborative team working on a client engagement."
                loading="lazy"
                width="1400"
                height="900"
                className="w-full h-56 object-cover"
              />
            </div>
            <a href="#contact" className="mt-8 inline-flex btn-gradient rounded-full px-6 py-3 font-semibold" data-testid="why-cta-btn">
              Start Your Project
            </a>
          </div>

        <div className="lg:col-span-2 grid grid-cols-1 sm:grid-cols-2 gap-4">
          {WHY_CHOOSE_US.map((f) => {
            const Icon = Icons[f.icon];
            return (
              <div key={f.title} className="card-lift card-tilt bg-white rounded-2xl border border-slate-100 p-5 flex gap-4 reveal" data-testid={`why-card-${f.title.toLowerCase().replace(/\s+/g, "-")}`}>
                <div className="w-11 h-11 rounded-xl bg-brand-gradient-soft flex items-center justify-center text-brand-purple shrink-0">
                  <Icon className="w-5 h-5" />
                </div>
                <div>
                  <div className="font-heading font-bold text-slate-900">{f.title}</div>
                  <div className="text-sm text-slate-500 mt-0.5">{f.desc}</div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  </section>
);
